'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _dec, _class, _dec2, _class2, _class3, _temp, _dec3, _class4, _class5, _temp2, _dec4, _dec5, _class6, _class7, _temp3; /*
                                                                                                                           SHARED FILE
                                                                                                                           
                                                                                                                           7 sites use this List module
                                                                                                                           
                                                                                                                           */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _reactScroll = require('react-scroll');

var _reactLoader = require('react-loader');

var _reactLoader2 = _interopRequireDefault(_reactLoader);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _container = require('../../helpers/container');

var _container2 = _interopRequireDefault(_container);

var _format = require('../../helpers/format');

var _format2 = _interopRequireDefault(_format);

var _convert = require('../../helpers/convert');

var _convert2 = _interopRequireDefault(_convert);

var _components = require('../../components');

var _search = require('redux/modules/search');

var searchActions = _interopRequireWildcard(_search);

var _List = require('./List.css');

var _List2 = _interopRequireDefault(_List);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// require('react-select/dist/react-select.css')


/*
 * GLOBALS
 *
 */
// columns to show when viewPanel==='results' vs. 'performance'
// for each view panel, 2d array where each column is [Label, field]
var PerformanceColumns = [['Fund name', 'name'], ['Expense ratio', 'prospectus_net_expense_ratio'], ['1-year', 'trailing_return_y1'], ['3-year', 'trailing_return_y3'], ['5-year', 'trailing_return_y5'], ['10-year', 'trailing_return_y10'], ['15-year', 'trailing_return_y15'], ['20-year', 'trailing_return_y20']];
var IyvColumns = [['Sustainability mandate', 'ussif'], ['Fossil fuels', 'grade_fossil'],
// ['Fossil finance grade', 'fossil_bank_score'],
// ['Fossil insurance grade', 'fossil_insure_score'],
['Deforestation', 'grade_deforestation'], ['Gender equality', 'grade_gender_equality'], ['Civilian firearms', 'grade_guns'], ['Prison industrial complex', 'grade_prison_industrial_complex'], ['Military weapons', 'grade_military'], ['Tobacco', 'grade_tobacco']];
var ResultsTableColumns = {
  'Invest Your Values': {
    results: [['Fund name', 'name']].concat(IyvColumns),
    performance: PerformanceColumns.concat([['Net assets', 'fund_net_assets'], ['Category', 'morningstar_category_name']])
  },
  'Gun Free Funds': {
    results: [['Fund name', 'name'], ['Civilian firearms grade', 'grade_guns'], ['Sustainability mandate', 'ussif'], ['Gun makers', 'gm_weight'], ['Gun retailers', 'gr_weight'], ['Gun makers + retailers', 'wff_civ_weight'], ['Net assets', 'fund_net_assets'], ['Category', 'morningstar_category_name']],
    performance: PerformanceColumns.concat([['Civilian firearms grade', 'grade_guns']]),
    iyv: [['Fund name', 'name']].concat(IyvColumns)
  },
  'Tobacco Free Funds': {
    results: [['Fund name', 'name'], ['Tobacco grade', 'grade_tobacco'], ['Sustainability mandate', 'ussif'], ['Tobacco companies', 'to_weight'], ['Tobacco-promoting studios', 'tm_weight'], ['Tobacco companies + studios', 't_all_weight'], ['Net assets', 'fund_net_assets'], ['Category', 'morningstar_category_name']],
    performance: PerformanceColumns.concat([['Tobacco grade', 'grade_tobacco']]),
    iyv: [['Fund name', 'name']].concat(IyvColumns)
  },
  'Deforestation Free Funds': {
    results: [['Fund name', 'name'], ['Deforestation grade', 'grade_deforestation'], ['Sustainability mandate', 'ussif'], ['Commodity producers', 'po_producer_weight'], ['Banks + lenders', 'po_financier_weight'], ['Consumer brands', 'po_consumer_weight'], ['Total deforestation risk exposure', 'po_all_weight'], ['Net assets', 'fund_net_assets'], ['Category', 'morningstar_category_name']],
    performance: PerformanceColumns.concat([['Deforestation grade', 'grade_deforestation']]),
    iyv: [['Fund name', 'name']].concat(IyvColumns)
  },
  'Weapon Free Funds': {
    results: [['Fund name', 'name'], ['Military weapons grade', 'grade_military'], ['Sustainability mandate', 'ussif'], ['Top 100 military contractors', 'mmc_weight'], ['Cluster munitions', 'cm_weight'], ['Nuclear weapons', 'nw_weight'], ['All military weapons exposure', 'wff_mil_weight'], ['Net assets', 'fund_net_assets'], ['Category', 'morningstar_category_name']],
    performance: PerformanceColumns.concat([['Military weapons grade', 'grade_military']]),
    iyv: [['Fund name', 'name']].concat(IyvColumns)
  },
  'Fossil Free Funds': {
    results: [['Fund name', 'name'], ['Fossil fuels', 'c2f5coogutweight'], ['Sustainability mandate', 'ussif'],
    // ['Fossil fuels', 'c2f5coogutweight'],
    // ['Carbon footprint', 'usd_relative_footprint'],
    ['Fossil finance', 'fossil_bank_score'], ['Fossil insurance', 'fossil_insure_score'], ['Clean200', 'cl_weight'], ['Net assets', 'fund_net_assets'], ['Category', 'morningstar_category_name']],
    performance: PerformanceColumns.concat([['Fossil fuels', 'grade_fossil']]),
    iyv: [['Fund name', 'name']].concat(IyvColumns)
  },
  'Gender Equality Funds': {
    results: [['Fund name', 'name'], ['Gender equality grade', 'grade_gender_equality'], ['Gender equality rank, by group', 'gef_grp_norm'], ['Gender equality score', 'gef_score'], ['Sustainability mandate', 'ussif'], ['Net assets', 'fund_net_assets'], ['Category', 'morningstar_category_name']],
    performance: PerformanceColumns.concat([['Gender equality grade', 'grade_gender_equality']]),
    iyv: [['Fund name', 'name']].concat(IyvColumns)
  },
  'Prison Free Funds': {
    results: [['Fund name', 'name'], ['Prison industrial complex grade', 'grade_prison_industrial_complex'], ['Sustainability mandate', 'ussif'], ['All flagged', 'pff_all_weight'], ['Higher risk, prison industry', 'pp_high_weight'], ['Higher risk, border industry', 'borders_high_weight'], ['Higher risk, both', 'pff_all_high_weight'], ['Private prison operators', 'pff_all_extreme_weight'], ['Net assets', 'fund_net_assets'], ['Category', 'morningstar_category_name']],
    performance: PerformanceColumns.concat([['Prison industrial complex grade', 'grade_prison_industrial_complex']]),
    iyv: [['Fund name', 'name']].concat(IyvColumns)
  }
};

var DefaultFilter = 'All funds';

var MarketOptionsFilters = ['fundFamily', 'currency', 'fundCategory', 'fundGroup'];

// GEF
var DEFAULT_GROUP_TYPE = 'group';

var Filters = [{ order: 0, label: 'Fund family', state: 'fundFamily', prop: 'ff' }, { order: 0, label: 'Fund group', state: 'fundGroup', prop: 'grp' }, { order: 0, label: 'Fund category', state: 'fundCategory', prop: 'fdc' }, {
  order: 0,
  label: 'Financial performance',
  state: 'fundPerformance',
  prop: 'perf'
}, { order: 1, label: 'Fund type', state: 'type', prop: 'typ' }, { order: 1, label: 'Diversified', state: 'diversified', prop: 'div' }, { order: 1, label: 'Target date', state: 'targetDate', prop: 'td' }, { order: 1, label: 'Sustainability mandate', state: 'sri', prop: 'sri' }, {
  order: 1,
  label: 'Forum for Sustainable and Responsible Investment (US-SIF)',
  state: 'fundUssif',
  prop: 'usf'
},

// {
//   order:1,
//   label:'A grade funds only',
//   state:'clean',
//   prop:'cln'
// },
//
{ order: 2, label: 'Fossil fuel grade', state: 'fffGrade', prop: 'fffgrd' }, { order: 2, label: 'Fossil finance grade', state: 'ffbGrade', prop: 'ffbgrd' }, { order: 2, label: 'Fossil insurance grade', state: 'ffiGrade', prop: 'ffigrd' }, { order: 2, label: 'Deforestation grade', state: 'dffGrade', prop: 'dffgrd' }, { order: 3, label: 'Gender equality grade', state: 'gefGrade', prop: 'gefgrd' }, { order: 3, label: 'Weapon grade', state: 'wffGrade', prop: 'wffgrd' }, { order: 3, label: 'Prison industrial complex grade', state: 'pffGrade', prop: 'pffgrd' }, { order: 3, label: 'Civilian firearm grade', state: 'gffGrade', prop: 'gffgrd' }, { order: 3, label: 'Tobacco grade', state: 'tffGrade', prop: 'tffgrd' }];

var propStateMap = [{
  state: 'searchQuery',
  prop: 'q',
  transform: function transform(value) {
    value = value.trim();
    return value === '' ? null : value;
  }
}, { state: 'page', prop: 'pg', transform: function transform(value) {
    return parseInt(value, 10);
  } }, { state: 'sort', prop: 'srt', transform: function transform(value) {
    return value;
  } }, {
  state: 'isDesc',
  prop: 'dsc',
  transform: function transform(value) {
    return _convert2.default.boolean(value);
  }
}];

/*
 * STATE MANAGEMENT VIA PROPS
 *
 */
var propsFromState = function propsFromState(state) {
  /*
   * convert state to query props
   */
  var props = {};

  propStateMap.forEach(function (map) {
    // in map
    if (typeof state[map.state] !== 'undefined' && state[map.state] !== null) {
      // has value after transform
      var value = map.transform(state[map.state]);

      if (typeof value !== 'undefined' && value !== null) {
        props[map.prop] = value;
      }
    }
  });

  Filters.forEach(function (filter) {
    if (state.selectedFilters[filter.state]) {
      var value = state.selectedFilters[filter.state];

      props[filter.prop] = value;
    }
  });

  // clean up url remove pg=1
  if (props.pg === 1) {
    delete props.pg;
  }

  // defaults to true
  if (props.dsc === true) {
    delete props.dsc;
  }

  return props;
};

var stateFromProps = function stateFromProps(props) {
  /*
   * convert query props to state
   */
  // defaults
  var state = {
    sort: 'ussif',
    isDesc: true,
    page: 1,
    searchQuery: '',
    selectedFilters: {},
    // screen: 'all',
    location: props.location
  };

  propStateMap.forEach(function (map) {
    // in map
    if (props.location.query[map.prop]) {
      // has value after transform
      var value = map.transform(props.location.query[map.prop]);

      if (typeof value !== 'undefined' && value !== null) {
        state[map.state] = value;
      }
    }
  });

  Filters.forEach(function (filter) {
    var value = props.location.query[filter.prop];
    if (value) {
      state.selectedFilters[filter.state] = value;
    }
  });

  // set input to query
  state = (0, _assign2.default)(state, {
    searchInput: state.searchQuery
  });

  // reset results if page === 1
  if (state.page === 1) {
    state = (0, _assign2.default)(state, {
      funds: [],
      lastResult: null
    });
  }

  return state;
};

/*
 *
 *
 *
 *
 *
 *
 * COMPONENTS
 */
var IyvListHeaderTitle = (_dec = (0, _reactCssModules2.default)(_List2.default, { allowMultiple: true }), _dec(_class = function (_Component) {
  (0, _inherits3.default)(IyvListHeaderTitle, _Component);

  function IyvListHeaderTitle() {
    (0, _classCallCheck3.default)(this, IyvListHeaderTitle);
    return (0, _possibleConstructorReturn3.default)(this, (IyvListHeaderTitle.__proto__ || (0, _getPrototypeOf2.default)(IyvListHeaderTitle)).apply(this, arguments));
  }

  (0, _createClass3.default)(IyvListHeaderTitle, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { styleName: 'list-header-title-panel' },
        _react2.default.createElement(
          _components.ContainerDivs,
          null,
          _react2.default.createElement(
            'div',
            { styleName: 'title' },
            'Mutual Funds & ETFs'
          )
        )
      );
    }
  }]);
  return IyvListHeaderTitle;
}(_react.Component)) || _class);
var IyvListTableMobileWraps = (_dec2 = (0, _reactCssModules2.default)(_List2.default, { allowMultiple: true }), _dec2(_class2 = (_temp = _class3 = function (_Component2) {
  (0, _inherits3.default)(IyvListTableMobileWraps, _Component2);

  //
  function IyvListTableMobileWraps(props) {
    (0, _classCallCheck3.default)(this, IyvListTableMobileWraps);
    return (0, _possibleConstructorReturn3.default)(this, (IyvListTableMobileWraps.__proto__ || (0, _getPrototypeOf2.default)(IyvListTableMobileWraps)).call(this, props));
  }
  //


  (0, _createClass3.default)(IyvListTableMobileWraps, [{
    key: 'render',
    value: function render() {
      var _this3 = this;

      var loaderFn = function loaderFn() {
        /* selectVisible = true when not mobile */
        /* selectVisible = false when mobile */
        return _react2.default.createElement(
          _reactLoader2.default,
          {
            options: { scale: 0.70, top: '150px' },
            loaded: _this3.props.page !== 1 || !_this3.props.loading
          },
          _react2.default.createElement(
            'div',
            { styleName: 'hidden-xs hidden-sm' },
            _react2.default.createElement(
              'div',
              {
                styleName: _this3.props.currentTutorial === 1 && _this3.props.showTutorial ? 'table-scroll tutorial-highlight-table' : 'table-scroll',
                onClick: _this3.props.clickCloseTutorial
              },
              _react2.default.createElement(_components.IyvListViewPanelTabs, {
                viewPanel: _this3.props.viewPanel,
                setViewPanel: _this3.props.setViewPanel
              }),
              _react2.default.createElement(_components.IyvListTable, {
                viewPanel: _this3.props.viewPanel,
                funds: _this3.props.funds,
                selectVisible: true,
                sort: _this3.props.sort,
                isDesc: _this3.props.isDesc,
                activeGrouping: _this3.props.activeGrouping,
                clickShareclass: _this3.props.clickShareclass,
                clickCompareSelect: _this3.props.clickCompareSelect,
                clickColumnHeader: _this3.props.clickColumnHeader,
                cart: _this3.props.cart,
                getCompareSelectStyles: _this3.props.getCompareSelectStyles,
                resultsTableColumns: _this3.props.resultsTableColumns
              })
            )
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'hidden-md hidden-lg' },
            _react2.default.createElement(_components.IyvListMobileTable, {
              viewPanel: _this3.props.viewPanel,
              funds: _this3.props.funds,
              selectVisible: true,
              sort: _this3.props.sort,
              isDesc: _this3.props.isDesc,
              activeGrouping: _this3.props.activeGrouping,
              clickShareclass: _this3.props.clickShareclass,
              clickCompareSelect: _this3.props.clickCompareSelect,
              clickColumnHeader: _this3.props.clickColumnHeader,
              cart: _this3.props.cart,
              getCompareSelectStyles: _this3.props.getCompareSelectStyles,
              resultsTableColumns: _this3.props.resultsTableColumns
            })
          ),
          _react2.default.createElement(_components.IyvListGetMoreFundsButton, {
            lastResult: _this3.props.lastResult,
            funds: _this3.props.lastResult,
            removeFilters: _this3.props.removeFilters,
            loading: _this3.props.loading,
            clickGetMoreFunds: _this3.props.clickGetMoreFunds
          }),
          /* To reduce the effect of things moving around on the page
             when a reload is happening */
          _this3.props.loading ? _react2.default.createElement('div', { style: {
              'height': '5000px',
              'width': '100%'
            } }) : null
        );
      };

      /* repeat this code 3 times to avoid animation issues with table */
      if (this.props.viewPanel === 'results') {
        return loaderFn();
      }
      if (this.props.viewPanel === 'performance') {
        return loaderFn();
      }
      if (this.props.viewPanel === 'iyv') {
        return loaderFn();
      }

      return null;
    }
  }]);
  return IyvListTableMobileWraps;
}(_react.Component), _class3.propTypes = {
  page: _react.PropTypes.number,
  loading: _react.PropTypes.bool,
  currentTutorial: _react.PropTypes.number,
  showTutorial: _react.PropTypes.bool,
  clickCloseTutorial: _react.PropTypes.func,
  viewPanel: _react.PropTypes.string,
  funds: _react.PropTypes.array,
  sort: _react.PropTypes.string,
  isDesc: _react.PropTypes.bool,
  activeGrouping: _react.PropTypes.string,
  clickShareclass: _react.PropTypes.func,
  clickCompareSelect: _react.PropTypes.func,
  clickColumnHeader: _react.PropTypes.func,
  cart: _react.PropTypes.object,
  lastResult: _react.PropTypes.array,
  removeFilters: _react.PropTypes.func,
  clickGetMoreFunds: _react.PropTypes.func,
  setViewPanel: _react.PropTypes.func,
  getCompareSelectStyles: _react.PropTypes.func,
  resultsTableColumns: _react.PropTypes.object
}, _temp)) || _class2);
var IyvListSpreadsheetExport = (_dec3 = (0, _reactCssModules2.default)(_List2.default, { allowMultiple: true }), _dec3(_class4 = (_temp2 = _class5 = function (_Component3) {
  (0, _inherits3.default)(IyvListSpreadsheetExport, _Component3);

  function IyvListSpreadsheetExport(props) {
    (0, _classCallCheck3.default)(this, IyvListSpreadsheetExport);
    return (0, _possibleConstructorReturn3.default)(this, (IyvListSpreadsheetExport.__proto__ || (0, _getPrototypeOf2.default)(IyvListSpreadsheetExport)).call(this, props));
  }

  (0, _createClass3.default)(IyvListSpreadsheetExport, [{
    key: 'render',
    value: function render() {
      var _this5 = this;

      return _react2.default.createElement(
        'div',
        { styleName: 'export-spreadsheet-wrap' },
        _react2.default.createElement(
          'div',
          { styleName: 'export-spreadsheet-txt' },
          'You can also export the fund grades as an Excel file.'
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'export-spreadsheet-link-wrap' },
          _react2.default.createElement(
            'button',
            {
              styleName: 'export-spreadsheet-btn',
              role: 'button',
              tabIndex: '0',
              title: 'Export spreadsheet',
              onClick: function onClick() {
                _this5.context.router.push(_config2.default.routes.howitworks + '#spreadsheet');
              }
            },
            'Download spreadsheet',
            _react2.default.createElement(_components.LinkIcon, { faclass: 'fa-download' }),
            _react2.default.createElement(_components.LinkIcon, { faclass: 'fa-file-excel-o' })
          )
        )
      );
    }
  }]);
  return IyvListSpreadsheetExport;
}(_react.Component), _class5.contextTypes = {
  router: _react.PropTypes.object.isRequired
}, _temp2)) || _class4);
var List = (_dec4 = (0, _reactRedux.connect)(function (state) {
  return {
    result: state.search.result,
    loading: state.search.loading,
    loaded: state.search.loaded,
    error: state.search.error,
    tutorialdismiss: state.tutorialdismiss.result,
    cart: state.cart.result
  };
}, searchActions), _dec5 = (0, _reactCssModules2.default)(_List2.default, { allowMultiple: true }), _dec4(_class6 = _dec5(_class6 = (_temp3 = _class7 = function (_Component4) {
  (0, _inherits3.default)(List, _Component4);

  /*
   * COMPONENT SETUP
   *
   */
  function List(props) {
    (0, _classCallCheck3.default)(this, List);

    var _this6 = (0, _possibleConstructorReturn3.default)(this, (List.__proto__ || (0, _getPrototypeOf2.default)(List)).call(this, props));

    _this6.searchFunds = function (state, noLimit) {
      _this6.props.searchFunds(state.searchQuery, state.page, state.sort, _this6.whereSearch(state), state.isDesc, noLimit);
    };

    _this6.whereSearch = function (state) {
      /*
        returns array of where conditions based on
        state.selectedFilters
       */
      var keys = (0, _keys2.default)(state.selectedFilters);

      var where = keys.map(function (filter) {
        var name = filter;
        var selectedFilter = state.selectedFilters[filter];

        if (!selectedFilter) {
          return null;
        }

        // console.log('filter:',filter,selectedFilter )
        var value = selectedFilter; // .value

        switch (filter) {
          case 'fundFamily':
            name = 'fund_family_name';
            break;
          case 'currency':
            name = 'currency_name';
            break;
          case 'sri':
            name = 'socially_responsible_fund';
            break;
          case 'fundUssif':
            name = 'ussif';
            break;
          case 'type':
            name = 'legal_type';
            break;
          case 'diversified':
            name = 'non_diversified_fund';
            break;
          case 'targetDate':
            name = 'is_target_date';
            break;
          case 'fundPerformance':
            name = value;
            value = 0;
            break;
          case 'fundCategory':
            name = 'morningstar_category_name';
            break;
          case 'fundGroup':
            name = 'category_group';
            break;
          // GFF
          case 'clean':
            // isClean = true
            name = 'wff_civ_count';
            value = 0;
            break;
          case 'fffGrade':
            name = 'grade_fossil';
            break;
          case 'ffbGrade':
            name = 'grade_fossil_bank';
            break;
          case 'ffiGrade':
            name = 'grade_fossil_insure';
            break;
          case 'dffGrade':
            name = 'grade_deforestation';
            break;
          case 'gefGrade':
            name = 'grade_gender_equality';
            break;
          case 'wffGrade':
            name = 'grade_military';
            break;
          case 'gffGrade':
            name = 'grade_guns';
            break;
          case 'pffGrade':
            name = 'grade_prison_industrial_complex';
            break;
          case 'tffGrade':
            name = 'grade_tobacco';
            break;
          default:
            break;
        }

        // console.log('value:',value,selectedFilter )
        if (selectedFilter.label === DefaultFilter) {
          return null;
        }

        if (filter === 'fundPerformance') {
          return { name: name, op: 'gt', value: value };
        }
        if (filter === 'fffGrade' || filter === 'ffbGrade' || filter === 'ffiGrade' || filter === 'dffGrade' || filter === 'gefGrade' || filter === 'wffGrade' || filter === 'gffGrade' || filter === 'pffGrade' || filter === 'tffGrade') {
          return { name: name, op: 'lte', value: parseFloat(value) || 0 };
        }

        return { name: name, op: 'eq', value: value };
      });

      return where;
    };

    _this6.selectFilter = function (name) {
      return function (val) {
        var valValue = val.value || val;
        var selectedFilters = (0, _assign2.default)({}, _this6.state.selectedFilters);

        if (name === 'market' && val) {
          (0, _keys2.default)(selectedFilters).filter(function (filterName) {
            // if the value is not in options set to default
            // this occurs because of dynamic options based on market
            var value = selectedFilters[filterName];
            // radio options are strings, dropdowns are objects
            var options = _this6.filterOptions(filterName, valValue);

            // console.log('option:',value, options )
            return !value || !options.find(function (option) {
              return value.value === option.value;
            });
          }).forEach(function (v) {
            return delete selectedFilters[v];
          });
        }
        selectedFilters[name] = !val || valValue === DefaultFilter ? null : valValue;
        _this6.context.router.push({
          pathname: _config2.default.routes.list,
          query: propsFromState((0, _assign2.default)(_this6.state, { selectedFilters: selectedFilters, page: 1 }))
        });
      };
    };

    _this6.removeSearchFilter = function () {
      _this6.context.router.push({
        pathname: _config2.default.routes.list,
        query: propsFromState((0, _assign2.default)(_this6.state, { searchQuery: '', page: 1 }))
      });
    };

    _this6.removeFilters = function () {
      var state = {
        page: 1,
        searchQuery: '',
        selectedFilters: {}
      };

      // this.setState(state)
      _this6.context.router.push({
        pathname: _config2.default.routes.list,
        query: propsFromState((0, _assign2.default)(_this6.state, state))
      });
    };

    _this6.removeFilter = function (prop) {
      return function () {
        var selectedFilters = (0, _assign2.default)({}, _this6.state.selectedFilters);
        delete selectedFilters[prop];
        _this6.context.router.push({
          pathname: _config2.default.routes.list,
          query: propsFromState((0, _assign2.default)(_this6.state, { page: 1, selectedFilters: selectedFilters }))
        });
      };
    };

    _this6.filterOptions = function (name, marketValue) {
      var foundOption = MarketOptionsFilters.find(function (option) {
        return name === option;
      });
      var optionsName = foundOption ? _this6.marketOptions(name, marketValue) : name;

      // console.log(config.formOptions)
      return _config2.default.formOptions[optionsName].map(function (option) {
        return {
          label: option.name,
          value: option.value || option.name
        };
      });
    };

    _this6.marketOptions = function (optionPrefix, marketValue) {
      /*
        Get the market specific version of options if market is selected
       */
      if (marketValue) {
        return optionPrefix + marketValue;
      }

      if (_this6.state.selectedFilters.market && _this6.state.selectedFilters.market !== DefaultFilter) {
        return optionPrefix + _this6.state.selectedFilters.market;
      }

      return optionPrefix + 'All';
    };

    _this6.resetCart = function () {
      _this6.props.cartChange([], {});
    };

    _this6.clickPrevTutorial = function () {
      var prevTutorialId = _this6.state.currentTutorial - 1;
      if (prevTutorialId >= 0) {
        _this6.setState({
          currentTutorial: prevTutorialId,
          showFilters: prevTutorialId === 2
        });
      }
    };

    _this6.clickNextTutorial = function () {
      var nextTutorialId = _this6.state.currentTutorial + 1;
      _this6.setState({
        currentTutorial: nextTutorialId,
        showFilters: nextTutorialId === 2
      });
    };

    _this6.clickCloseTutorial = function () {
      if (_this6.state.showTutorial) {
        _this6.props.tutorialdismissChange(true);
        _this6.setState({
          showTutorial: false,
          currentTutorial: -1
        });
      }
    };

    _this6.clickTutorialRestart = function () {
      _this6.setState({
        showTutorial: true,
        currentTutorial: 0
      });
    };

    _this6.clickSearch = function () {
      _this6.context.router.push({
        pathname: _config2.default.routes.list,
        query: propsFromState((0, _assign2.default)(_this6.state, {
          page: 1, searchQuery: _this6.state.searchInput || ''
        }))
      });
    };

    _this6.clickToggleFilters = function () {
      _this6.setState({
        showFilters: !_this6.state.showFilters
      });
    };

    _this6.clickColumnHeader = function (prop) {
      var asc = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      return function () {
        var isDesc = null;
        if (asc) {
          isDesc = asc === 'desc';
        } else {
          isDesc = prop === _this6.state.sort ? !_this6.state.isDesc : true;
        }

        _reactScroll.scroller.scrollTo('table-top', {
          duration: 100,
          // delay: 100,
          smooth: true,
          // containerId: 'ContainerElementID',
          offset: 50 });

        _this6.context.router.push({
          pathname: _config2.default.routes.list,
          query: propsFromState((0, _assign2.default)(_this6.state, {
            sort: prop,
            isDesc: isDesc,
            page: 1 }))
        });
      };
    };

    _this6.clickCompareSelect = function (shareclass) {
      _this6.props.cartChange(_this6.props.cart.results, shareclass);
    };

    _this6.clickShareclass = function (shareclass) {
      var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var ticker = shareclass.ticker,
          fund_legal_name = shareclass.fund_legal_name,
          fund_id = shareclass.fund_id,
          investment_vehicle_id = shareclass.investment_vehicle_id;

      // make ticker safe for URL

      var sTicker = ticker || 'N';

      var urlBuilder = function urlBuilder(route, profilePath) {
        return route + '/' + _format2.default.sanitize(fund_legal_name) + '/' + sTicker + '/' + profilePath + '/' + fund_id + '/' + investment_vehicle_id;
      };

      var url = urlBuilder(_config2.default.routes.fund, page || _config2.default.profilePath);

      // return a function that when called navigates to this URL
      return function () {
        _this6.context.router.push(url);
      };
    };

    _this6.clickGetMoreFunds = function () {
      _this6.context.router.push({
        pathname: _config2.default.routes.list,
        query: propsFromState((0, _assign2.default)(_this6.state, { page: _this6.state.page + 1 }))
      });
    };

    _this6.setViewPanel = function (v) {
      _this6.setState({ viewPanel: v });
    };

    _this6.getCompareSelectStyles = function (cart, investment_vehicle_id) {
      var inCart = false;
      var allFull = true;
      if (cart && cart.results && cart.results.length) {
        for (var i = 0; i < cart.results.length; i++) {
          // if we find an N we are not all full
          if (cart.results[i].id === 'N') {
            allFull = false;
          }
          // if we find a match we are in cart
          if (cart.results[i].id === investment_vehicle_id) {
            inCart = true;
          }
        }
      }

      var className = inCart ? 'fa fa-check-square-o fa-2x' : 'fa fa-square-o fa-2x';

      var styleName = !inCart && allFull ? 'disabled' : '';

      return { className: className, styleName: styleName };
    };

    _this6.onSearchInputChange = function (event) {
      _this6.setState({ searchInput: event.target.value });
    };

    _this6.handleKeyPress = function (e) {
      if (e.key === 'Enter') {
        _this6.clickSearch();
      }
    };

    _this6.changeActiveGrouping = function (newGrouping) {
      if (typeof newGrouping === 'string' && newGrouping !== _this6.state.activeGrouping && (newGrouping === 'rank' || newGrouping === 'peer' || newGrouping === 'group')) {
        // set state
        _this6.setState({
          activeGrouping: newGrouping
        });

        // switch prop for header based on new grouping
        var prop = '';
        switch (newGrouping) {
          case 'rank':
            prop = 'gef_rank';
            break;
          case 'peer':
            prop = 'gef_peer_norm';
            break;
          case 'group':
            prop = 'gef_grp_norm';
            break;
        }

        // clickColumnHeader returns a function using the prop; call it
        _this6.clickColumnHeader(prop)();
      }
    };

    var tutorialdismiss = _this6.props.tutorialdismiss;
    var dflt = DEFAULT_GROUP_TYPE;
    var initState = stateFromProps(props);
    switch (initState.sort) {
      case 'gef_peer_norm':
        dflt = 'peer';
        break;
      case 'gef_rank':
        dflt = 'rank';
        break;
      default:
        break;
    }
    _this6.state = (0, _assign2.default)(initState, {
      funds: [],
      lastResult: null,
      showTutorial: false, // !tutorialdismiss,
      currentTutorial: 0,
      showFilters: false,
      // showScreens: false,
      viewPanel: 'results',
      activeGrouping: dflt
    });
    return _this6;
  }

  (0, _createClass3.default)(List, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      // search with no limits
      if (typeof window !== 'undefined') {
        window.scrollTo(0, 0);
      }
      this.searchFunds(this.state, true);
      if (!this.props.cart) {
        this.props.cartChange();
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.tutorialdismissChange(this.props.tutorialdismiss || false);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      // did the location change? trigger a new search
      if (props.location !== this.state.location) {
        var state = (0, _assign2.default)(this.state, stateFromProps(props));
        // set state
        this.setState(state);
        // update the screen
        // this.selectScreen(state.screen)
        // search again
        this.searchFunds(state);
        // has results, new result, and orderby (not the home page)
      } else if (props.result && props.result.results && props.result.orderBy && this.state.lastResult !== props.result.results) {
        // setting results from query
        // update the screen
        // const state = Object.assign(this.state, stateFromProps(props))
        // this.selectScreen(state.screen)
        this.setState({
          lastResult: props.result.results,
          funds: this.state.funds.concat(props.result.results)
        });
      }
    }

    /*
     * CALLING THE API
     *
     */


    /*
     * MANAGING FILTERS
     *
     */


    /*
     * ON CLICKS + INPUTS
     *
     */


    /*
     * TEXT INPUT
     *
     */

    /**
     * Update state with new active grouping, to be used in displaying
     * percentile ranks and color sliders, and controlled by a form control.
     * Changing form control calls changeActiveGrouping() with the newly
     * selected grouping.
     *
     * @param  {String} newGrouping - Either 'rank', 'peer', or 'group'
     */

  }, {
    key: 'render',


    /*
     * MAIN RENDER
     *
     */
    value: function render() {
      // if there's an error with the API results, go to 404 page
      if (this.props.result && this.props.result.results && this.props.result.results.error) {
        this.context.router.push(_config2.default.routes.notFound);
        return _react2.default.createElement(
          'div',
          { styleName: 'main' },
          _react2.default.createElement(_reactLoader2.default, {
            options: { scale: 0.70, top: '2.0rem' },
            loaded: false
          })
        );
      }

      return _react2.default.createElement(
        'div',
        { styleName: 'main' },
        _container2.default.helmet('Search funds', _config2.default.app.description, _config2.default.domain + _config2.default.routes.clean),
        _react2.default.createElement(IyvListHeaderTitle, null),
        _react2.default.createElement(
          _components.ContainerDivs,
          null,
          _react2.default.createElement(_components.IyvListSearchBar, {
            currentTutorial: this.state.currentTutorial,
            showTutorial: this.state.showTutorial,
            clickCloseTutorial: this.clickCloseTutorial,
            onSearchInputChange: this.onSearchInputChange,
            searchInput: this.state.searchInput,
            handleKeyPress: this.handleKeyPress,
            clickSearch: this.clickSearch
          }),
          _react2.default.createElement(_components.IyvListTutorial, {
            showTutorial: this.state.showTutorial,
            currentTutorial: this.state.currentTutorial,
            clickPrevTutorial: this.clickPrevTutorial,
            clickNextTutorial: this.clickNextTutorial,
            clickCloseTutorial: this.clickCloseTutorial
          }),
          _react2.default.createElement(_components.IyvListSearchSettingsButton, {
            currentTutorial: this.state.currentTutorial,
            showTutorial: this.state.showTutorial,
            clickCloseTutorial: this.clickCloseTutorial,
            clickToggleFilters: this.clickToggleFilters,
            showFilters: this.state.showFilters
          }),
          _react2.default.createElement(_components.IyvListFilters, {
            activeGrouping: this.state.activeGrouping,
            showFilters: this.state.showFilters,
            currentTutorial: this.state.currentTutorial,
            showTutorial: this.state.showTutorial,
            clickCloseTutorial: this.clickCloseTutorial,
            changeActiveGrouping: this.changeActiveGrouping,
            selectFilter: this.selectFilter,
            filterOptions: this.filterOptions,
            selectedFilters: this.state.selectedFilters,
            defaultFilter: DefaultFilter,
            filters: Filters
          })
        ),
        _react2.default.createElement(_reactScroll.Element, { name: 'table-top' }),
        _react2.default.createElement(
          'div',
          { styleName: 'table-wrapper' },
          _react2.default.createElement(
            'div',
            { styleName: 'wrap-tutorial-restart-active-filters' },
            _react2.default.createElement(_components.IyvListTutorialRestartButton, {
              clickTutorialRestart: this.clickTutorialRestart
            }),
            _react2.default.createElement(_components.IyvListActiveFilters, {
              searchQuery: this.state.searchQuery,
              removeFilter: this.removeFilter,
              removeFilters: this.removeFilters,
              removeSearchFilter: this.removeSearchFilter,
              selectedFilters: this.state.selectedFilters,
              filterOptions: this.filterOptions,
              defaultFilter: DefaultFilter
            })
          ),
          _react2.default.createElement(IyvListTableMobileWraps, {
            loading: this.props.loading,
            cart: this.props.cart,
            page: this.state.page,
            currentTutorial: this.state.currentTutorial,
            showTutorial: this.state.showTutorial,
            viewPanel: this.state.viewPanel,
            funds: this.state.funds,
            lastResult: this.state.lastResult,
            sort: this.state.sort,
            isDesc: this.state.isDesc,
            activeGrouping: this.state.activeGrouping,
            clickCloseTutorial: this.clickCloseTutorial,
            clickShareclass: this.clickShareclass,
            clickCompareSelect: this.clickCompareSelect,
            clickColumnHeader: this.clickColumnHeader,
            removeFilters: this.removeFilters,
            clickGetMoreFunds: this.clickGetMoreFunds,
            setViewPanel: this.setViewPanel,
            getCompareSelectStyles: this.getCompareSelectStyles,
            resultsTableColumns: ResultsTableColumns
          }),
          _react2.default.createElement(_components.IyvListCart, {
            cart: this.props.cart,
            resetCart: this.resetCart,
            cartChange: this.props.cartChange,
            clickCompareSelect: this.clickCompareSelect
          })
        )
      );
    }
  }]);
  return List;
}(_react.Component), _class7.propTypes = {
  loading: _react.PropTypes.bool,
  loaded: _react.PropTypes.bool,
  error: _react.PropTypes.object,
  result: _react.PropTypes.object,
  search: _react.PropTypes.func,
  tutorialdismiss: _react.PropTypes.bool,
  cart: _react.PropTypes.object
}, _class7.contextTypes = {
  router: _react.PropTypes.object.isRequired
}, _temp3)) || _class6) || _class6);
exports.default = List;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/List/List.js
// module id = 1412
// module chunks = 0